<template>
  <div class="popup_header">
    <h1>포인트 전환 신청</h1>
    <ul class="exchange_step" v-if="$route.name != 'errorPage'">
      <li v-for="(el, idx) in step" :key="idx" :class="{ active: el == $route.name }">
        <span>{{ idx + 1 }}</span>
      </li>
    </ul>
    <div class="bt">
      <v-button @handleClick="handleClick()" class="btn_close2" text="close" :textHide="true" />
    </div>
  </div>
</template>

<script>
import VButton from '@/components/atoms/VButton';
export default {
  components: {
    VButton,
  },
  data() {
    return {
      step: ['Step1', 'Step2', 'Step3', 'Step4'],
    };
  },
  methods: {
    handleClick() {
      window.parent.postMessage({ event: 'iframeClose', data: null }, '*');
    },
  },
};
</script>
